exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#window-ribbon {\n  background-color: rgb(150, 96, 155)!important;\n  border-radius: .25rem;\n}\n\n.win_close.sqico-larrow {\n  background-color: rgb(150, 96, 155)!important;\n}\n\n.zsiq_cnt {\n  display: none!important;\n}", ""]);

